"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import classnames from "classnames";

import styles from "./styles.module.scss";

const links = [
  { href: "/portfolio", label: "Work" },
  { href: "/skills", label: "Skills" },
  { href: "/contacts", label: "Contact" },
];

export const Menu = () => {
  const pathname = usePathname();
  const currentPage = (pathname || "/").split("/")[1];

  return (
    <nav className={styles.nav}>
      <div className={styles.links}>
        {links.map(({ href, label }) => (
          <Link
            key={href}
            href={href}
            className={classnames(styles.link, {
              [styles.active]: href === `/${currentPage}`,
            })}
          >
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
};
